import React from 'react';
import './AboutImage.scss';

function AboutImage() {
    return (
        <div className="aboutImage">
        <div className="block">
            <div className="side -main"></div>
            <div className="side -left"></div>
        </div>
        <div className="block">
            <div className="side -main"></div>
            <div className="side -left"></div>
        </div>
        <div className="block">
            <div className="side -main"></div>
            <div className="side -left"></div>
        </div>
    </div>
    )
}

export default AboutImage;
